import { authAxios } from "../utils/axios/auth.axios";

const loginUser = async (username, password) => {
  try {
    const response = await authAxios.post("/user/login", {
      user_name: username,
      password,
    });

    return response;
  } catch (error) {
    return error;
  }
};

const sendOTP = async (username) => {
  try {
    const response = await authAxios.get("/user/otp/email", {
      params: {
        user_name: username,
      },
    });

    return response;
  } catch (error) {
    return error;
  }
};

const verifyOTP = async (otp, username) => {
  try {
    const response = await authAxios.post("/user/verify/email", {
      otp,
      user_name: username,
    });

    return response;
  } catch (error) {
    return error;
  }
};

const changePassword = async (newPass, confirmPass) => {
  try {
    const response = await authAxios.patch("/user/password", {
      password: newPass,
      confirmPassword: confirmPass,
      secret: sessionStorage.getItem("secret"),
      user_name: sessionStorage.getItem("username"),
    });

    return response;
  } catch (error) {
    return error;
  }
};

export { loginUser, sendOTP, verifyOTP, changePassword };
